export class Currency {
  code: string;
  id: number;
  isDeletable: boolean;
  name: string;
  sign: string;
  exchangeRate: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Currency.ts